import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';

export class DojoMenu extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`DojoMenu`);
		this.attachShadow({mode:`open`});
		this.shadowRoot.appendChild(this.el);
		Eventify(this.shadowRoot, this);
		// Turns out it's much easier if the menu is hidden by default, or at least
		// it seems that way for me.
		// if (`hide`==this.getState()) {
			this.$.menu.classList.add(`hide`);
		// }
	}
	setState(state) {
		window.sessionStorage.setItem(`dojo-menu-toggle`, state);
	}
	getState() {
		return window.sessionStorage.getItem(`dojo-menu-toggle`);
	}
	connectedCallback() {}
	toggleDisplay(evt) {
		evt.stopPropagation();
		if (this.$.menu.classList.contains(`hide`)) {
			this.$.menu.classList.remove(`hide`);
			this.setState(``);
		} else {
			this.$.menu.classList.add(`hide`);
			this.setState(`hide`);
		}
	}
}

customElements.define(`dojo-menu`, DojoMenu);